import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import * as echarts from 'echarts';

const styles = {
  graphDimensions: {
    width: '40vw',
    height: '60vh',
    marginTop: '30px',
  },
};

class BasicBarGraph extends Component {
  constructor(props) {
    super(props);

    this.chart = null;
    this.chartRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.chartRef.current !== null) {
      this.chart = echarts.init(this.chartRef.current);

      if (prevProps.datas !== this.props.datas) {
        this.chart.setOption({
          color: this.props.colors || ['#95D178' /** Green */, '#EE6766' /** Red */, '#5470C6' /** blue */],
          tooltip: {
            trigger: 'item',
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: '70%',
              data: this.props.datas,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
            },
          ],
        });

        if (this.props.handleSeriesClick) {
          this.chart.on('click', 'series', this.props.handleSeriesClick);
        }
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div id="logins-chart" className={classes.graphDimensions} ref={this.chartRef} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BasicBarGraph);



// WEBPACK FOOTER //
// ./src/components/graphs/BasicPieGraph.jsx